import { render, staticRenderFns } from "./evaluationList.vue?vue&type=template&id=35cc052c&scoped=true"
import script from "./evaluationList.vue?vue&type=script&lang=js"
export * from "./evaluationList.vue?vue&type=script&lang=js"
import style0 from "./evaluationList.vue?vue&type=style&index=0&id=35cc052c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cc052c",
  null
  
)

export default component.exports